var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconGeneric(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 67.12 72.41",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33.56 43.86-6.72 6.85-25.17-12.85 6.71-6.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.56 43.86 6.71 6.85 25.18-12.85-6.71-6.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.74 31-25.18 12.86-25.18-12.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.56 71.29v-27.43"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.38 41.29v17.14l25.18 12.86 25.18-12.86v-17.14"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m33.56 31v-30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.13 32.72-12.5-21.65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.99 32.72 12.5-21.65"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m47.7 25.36 11.04 5.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.56 19.67 5.79 2.96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m24.77 22.63 5.79-2.96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.38 31 11.04-5.64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.29 17.42 13.16 6.72-6.71 6.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.56 15.08 3.71-3.79 6.67 3.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.83 17.42-13.16 6.72 6.71 6.86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.56 15.08-3.72-3.79-6.66 3.4"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGeneric);
export default __webpack_public_path__ + "static/media/icon_generic.9dac0eee327f0de1385db43219829417.svg";
export { ForwardRef as ReactComponent };